import { defineAsyncComponent } from 'vue';

// всё, что ниже первого экрана (карта, листинг, FAQ, подписка, 404), уходит в отдельные чанки,
// чтобы не раздувать стартовый бандл и не конкурировать с загрузкой главного фото (LCP)
const loadSightLocation = () => import('../components/SightLocation.vue');

export const Attractions = defineAsyncComponent(() => import('@/entities/attraction').then((m) => m.Attractions));
export const ExperienceListingStandalone = defineAsyncComponent(() =>
  import('@/features/experienceListing').then((m) => m.ExperienceListingStandalone),
);
export const FaqSection = defineAsyncComponent(() => import('@/widgets/faqSection').then((m) => m.FaqSection));
export const SightLocation = defineAsyncComponent(loadSightLocation);
export const SubscriptionBlock = defineAsyncComponent(() =>
  import('@experience/subscription-block-package').then((m) => m.SubscriptionBlock),
);
export const NotFoundBlock = defineAsyncComponent(() =>
  import('@experience/site-404-package').then((m) => m.NotFoundBlock),
);

/** Чанк карты нужен сразу (блок выше статьи): начинаем грузить его, не дожидаясь ответа API. */
export const preloadSightLocation = () => {
  void loadSightLocation();
};
